export const ERROR_PAGE_CODES = [
  400, 401, 403, 404, 408, 409, 422, 429, 500, 503,
] as const;

export type ErrorPageCode = (typeof ERROR_PAGE_CODES)[number];

const ERROR_PAGE_CODE_SET = new Set<number>(ERROR_PAGE_CODES);

export function normalizeErrorPageCode(
  value: unknown,
  fallback: ErrorPageCode = 500,
): ErrorPageCode {
  const numericValue =
    typeof value === 'string' && value.trim() === ''
      ? Number.NaN
      : Number(value);

  return ERROR_PAGE_CODE_SET.has(numericValue)
    ? (numericValue as ErrorPageCode)
    : fallback;
}
